import { useState } from "react";
import {
  Box,
  Image as MantineImage,
  ImageProps as MantineImageProps,
  Overlay,
  Portal,
  UnstyledButton,
} from "@mantine/core";
import { useHover } from "@mantine/hooks";
import styles from "./styles.module.css";
import SVGAsset from "@/components/atoms/SVGAsset/SVGAsset";

interface ImageProps extends Omit<MantineImageProps, "onClick"> {
  src: string;
  withFullscreen?: boolean;
}

export default function Image({ src, withFullscreen = false, ...imageProps }: ImageProps) {
  const [isFullscreen, setIsFullscreen] = useState(false);
  const { hovered, ref } = useHover<HTMLDivElement>();

  if (!withFullscreen) {
    return <MantineImage src={src} {...imageProps} />;
  }

  return (
    <>
      <Box ref={ref} className={styles.root} onClick={() => setIsFullscreen(true)}>
        <MantineImage src={src} {...imageProps} />
        {hovered && (
          <Overlay>
            <UnstyledButton className={styles.overlayButton}>
              <SVGAsset name="full-screen" />
            </UnstyledButton>
          </Overlay>
        )}
      </Box>

      {isFullscreen && (
        <Portal>
          <Overlay backgroundOpacity={0.85} fixed className={styles.fullscreenOverlay}>
            <UnstyledButton className={styles.closeButton} onClick={() => setIsFullscreen(false)}>
              <SVGAsset name="close-fullscreen" />
            </UnstyledButton>
            <MantineImage src={src} fit="contain" style={{ maxWidth: "80vw", maxHeight: "80vh" }} />
          </Overlay>
        </Portal>
      )}
    </>
  );
}
